import { render, staticRenderFns } from "./package-detail.vue?vue&type=template&id=620ecc83&scoped=true"
import script from "./package-detail.vue?vue&type=script&lang=ts"
export * from "./package-detail.vue?vue&type=script&lang=ts"
import style0 from "./package-detail.vue?vue&type=style&index=0&id=620ecc83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ecc83",
  null
  
)

export default component.exports